export class RegisterModel {
    userType: string;
    profileName: string;
    email: string;
    password: string;
    confirm: string;
    acceptTerms: boolean;
}



// WEBPACK FOOTER //
// ./src/models/account/register.model.ts